import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import {CreatedMaintenanceRecordRequest} from '@di-shared/api/di/__generated';
import {DEFAULT_CACHE_TIME} from '@di-shared/const';

function useSestCodeToName() {
  const {data: sestItems} = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.maintenancesSestController.getSestItems1)],
    queryFn: () => diApi.maintenancesSestController.getSestItems1(),
    select: (data) => data.data,
    ...DEFAULT_CACHE_TIME,
  });

  function convertSestCodeToName(sestCode: CreatedMaintenanceRecordRequest.sestCode) {
    return sestItems.find((item) => item.code === sestCode)?.name || '';
  }

  function convertSestCodesToNames(sestCodes: CreatedMaintenanceRecordRequest.sestCode[]) {
    return sestCodes.map(convertSestCodeToName);
  }

  return {convertSestCodesToNames, convertSestCodeToName};
}

export default useSestCodeToName;
